var render = function () {
  var _vm$value, _vm$value$thumb;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, [_c('v-img', {
    staticClass: "grey-f8",
    attrs: {
      "src": (_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$thumb = _vm$value.thumb) === null || _vm$value$thumb === void 0 ? void 0 : _vm$value$thumb.src,
      "width": "233",
      "aspect-ratio": 282 / 438
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function fn() {
        return [_c('v-overlay', {
          attrs: {
            "absolute": "",
            "color": "transparent"
          }
        }, [_c('v-icon', {
          attrs: {
            "x-large": "",
            "color": "grey-b3"
          }
        }, [_vm._v("mdi-image-broken-variant")])], 1)];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-col', [_c('v-chip-group', {
    staticClass: "mb-8"
  }, [_c('v-chip', {
    attrs: {
      "outlined": "",
      "label": "",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(" " + _vm._s(_vm.value._employees.length.format()) + "명 참여 ")])]), _c('v-chip', {
    attrs: {
      "outlined": "",
      "label": "",
      "color": "secondary"
    }
  }, [_c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(" " + _vm._s(_vm.value._employers.length.format()) + "개 기업 참여 ")])])], 1), _c('a', {
    attrs: {
      "href": "/programs/".concat(_vm.value._id)
    }
  }, [_c('h5', {
    staticClass: "tit--sm d-inline font-weight-bold text-truncate mb-8"
  }, [_vm._v(" " + _vm._s(_vm.value.subject) + " ")])]), _c('p', {
    staticClass: "page-text--lg font-weight-regular text-truncate primary--text mb-24"
  }, [_vm._v(" " + _vm._s(_vm.value.host.name) + " ")]), _c('p', {
    staticClass: "page-text mb-24"
  }, [_vm._v(" " + _vm._s(_vm.value.summary) + " ")]), _c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-row', {
    staticClass: "mt-0 mx-0 mb-24",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "grey-f7",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "font-weight-medium text-center",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 프로그램 진행기간 ")]), _c('v-col', {
    staticClass: "font-weight-regular grey--text",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.date.programDisplay.text) + " ")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "font-weight-medium text-center",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 기업회원 접수기간 ")]), _c('v-col', {
    staticClass: "font-weight-regular grey--text",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.date.employerSubmit.text) + " ")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "font-weight-medium text-center",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 개인회원 접수기간 ")]), _c('v-col', {
    staticClass: "font-weight-regular grey--text",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.date.employeeSubmit.text) + " ")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "font-weight-medium text-center",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 매칭기간 ")]), _c('v-col', {
    staticClass: "font-weight-regular grey--text",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.date.matchingSubmit.text) + " ")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "font-weight-medium text-center",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 면접기간 ")]), _c('v-col', {
    staticClass: "font-weight-regular grey--text",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.date.interviewSpans.text) + " ")])], 1)], 1)], 1), _vm._t("actions")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }